import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone } from "lucide-react";

export function CallsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Phone Calls</h2>
        <p className="text-muted-foreground">Track customer communications</p>
      </div>

      <Card>
        <CardContent className="py-8 text-center">
          <Phone className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold mb-2">Call Tracking Coming Soon</h3>
          <p className="text-muted-foreground">
            Phone call management functionality will be available in the next phase.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}